<template>
    <v-container fluid>
        <!-- Header section with satisfaction percentage and title -->
        <v-row class="align-center">
            <v-col class="text-center">
                <h3>{{title}}</h3>
            </v-col>
        </v-row>

        <!-- Full-width chart -->
        <v-row>
            <v-col cols="12" style="height: 400px;">
                <BarChart :data="chartData" :options="chartOptions" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import { Bar } from 'vue-chartjs'
    import { Chart, registerables } from 'chart.js'

    // Create a custom Chart instance
    const CustomChart = Chart
    CustomChart.register(...registerables)

    // Define the custom plugins
    const xAxisImagesPlugin = {
        id: 'xAxisImages',
        afterDraw(chart) {
            const { ctx } = chart
            chart.data.labels.forEach((label, index) => {
                try{
                const xPosition = chart.scales['x'].getPixelForTick(index)
                const yPosition = chart.scales['y'].bottom - 10

                const image = new Image()
                image.src = chart.config.options.customLogos[index]
                image.onload = () => {
                    ctx.drawImage(image, xPosition - 15, yPosition, 35, 35)
                    ctx.font = '12px Arial'
                    ctx.fillStyle = '#333'
                    ctx.textAlign = 'center'
                    ctx.fillText(label, xPosition, yPosition + 45)
                }

                }
                catch(ex){}
            })
        },
    }

    const averageLinePlugin = {
        id: 'averageLine',
        afterDraw(chart) {
            try{
            const { ctx, chartArea, scales } = chart
            const yAxis = scales['y']

            const average = chart.config.options.customAverage
            const yPosition = yAxis.getPixelForValue(average)

            ctx.save()
            ctx.setLineDash([5, 5])
            ctx.strokeStyle = '#FFD700'
            ctx.lineWidth = 2
            ctx.beginPath()
            ctx.moveTo(chartArea.left, yPosition)
            ctx.lineTo(chartArea.right, yPosition)
            ctx.stroke()

            ctx.font = 'bold 12px Arial'
            ctx.fillStyle = '#FFD700'
            ctx.textAlign = 'center'
            ctx.fillText(`${average.toFixed(0)}%`, chartArea.right - 20, yPosition - 10)

            ctx.restore()

            }
            catch(ex){}
        },
    }

    // Register plugins with the custom Chart instance
    CustomChart.register(xAxisImagesPlugin, averageLinePlugin)

    export default {
        components: {
            BarChart: {
                extends: Bar,
                props: ['data', 'options'],
                mounted() {
                    try {
                        this.renderChart(this.data, this.options)
                    }
                    catch(e) { }
                },
            },
        },
        props: {
            satisfactionLabels: {
                type: Array,
                default: () => [],
            },
            satisfactionLogos: {
                type: Array,
                default: () => [],
            },
            satisfactionData: {
                type: Array,
                default: () => [],
            },
            title: {
                type: String,
                default: () => '',
            },
        },
        data() {
            const average = this.satisfactionData.reduce((a, b) => a + b, 0) / this.satisfactionData.length
            return {
                chartData: {
                    labels: this.satisfactionLabels,
                    datasets: [
                        {
                            label: 'الرضا',
                            backgroundColor: '#00ACC1',
                            data: this.satisfactionData,
                        },
                    ],
                },
                chartOptions: {
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        xAxisImages: {}, // Activate xAxisImagesPlugin
                        averageLine: {}, // Activate averageLinePlugin
                    },
                    customLogos: this.satisfactionLogos, // Pass custom logos to the plugin
                    customAverage: average, // Pass average to the plugin
                    scales: {
                        y: {
                            beginAtZero: true,
                            max: 100,
                            ticks: {
                                callback: (value) => `${value}%`,
                            },
                        },
                        x: {
                            ticks: {
                                display: true,
                                font: {
                                    size: 12,
                                },
                                color: '#333',
                            },
                        },
                    },
                },
            }
        },
    }
</script>

<style scoped>
    .satisfaction-percentage {
        font-size: 24px;
        font-weight: bold;
    }
</style>
